import React, {PropTypes} from 'react';
import { PageHeader, Row, Col, Grid, Image, Thumbnail, Well } from 'react-bootstrap';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
// LOCAL
import AddMemberForm from './components/AddMemberForm'
// SHARED
import BackNavLink from '../core/components/BackNavLink'
import muiTheme from '../utils/muiTheme'
import { FieldGroup } from '../core/components/FieldGroup';
import { connect } from 'react-redux'

const mapStateToProps = (state, ownProps) => {
  return {
    shareLink: `https://dashboard.everlance.com/signup?gt=${state.accountants.tokenId}`,
    ...state
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    handleSubmit: (values) => {
      // Reeplace new lines with comma, remove blank spaces, split and then join again into a string
      var data = {}
      // TODO move this to action or API
      data.emails = values.emails.replace(/\n/g, ",").replace(/\s/g,"").split(",").join()

      const { onNewClientFormSubmit } = ownProps
      onNewClientFormSubmit(data)
    },
    handleFocus: (event) => {
      event.target.select();
    }
  }
}

const ShareTextWithLink = ({shareLink}) =>
    <div className="ShareTextWithLink">
      <p>Hi there,</p>
      <p>I recommend downloading this great mileage and expense tracking app. It can automatically track your miles, so you’ll never miss a mile or need to keep a paper log again.</p>
      <p>If you download the app through my unique link below, you’ll be set up as my client and you'll be able to send me your reports from Everlance. One less thing for you to worry about.</p>
      <p className="share-link">{shareLink}</p>
      <p>Let me know if you have any questions!</p>
    </div>



const MainContentNewClient = ({shareLink, user, ui, onCreateClientInvitesFormReset, handleSubmit, handleFocus}) =>
  <div className="main-content-component main-content-new-client">
    <BackNavLink to="/accountants" />

    <PageHeader>Invite Clients
    {/* <small>When clients sign up with the invite or link below, we’ll connect them to you, so you can access their reports.</small> */}
    </PageHeader>
    <Grid className="main-container" fluid={true}>
      <Row className="show-grid">
        <Col xs={12} sm={12} md={12}>
            <h3 className="column-title send-invite-option"><span style={{color: "#888888"}}>Option 1 (Recommended):</span> Invite your clients directly</h3>
            <p className="column-title-subcopy">Enter your clients' emails and we'll send them an invite. (Please separate multiple emails with a comma or a new line)</p>

            <MuiThemeProvider muiTheme={muiTheme}>
              <AddMemberForm
                onSubmit={handleSubmit}
                createMemberInvitesForm={ui.createClientInvitesForm}
                onCreateMemberInvitesFormReset={onCreateClientInvitesFormReset}
              />
            </MuiThemeProvider>

        </Col>
      </Row>
      <Row className="show-grid">
        <Col xs={12} sm={12} md={12}>
          <p className="full-width-center-text">or</p>
        </Col>
      </Row>
      <Row className="show-grid">
        <Col xs={12} sm={12} md={12}>

          <h3 className="column-title"><span style={{color: "#888888"}}>Option 2:</span>  Share your unique link with your clients</h3>
          <p className="column-title-subcopy">Copy/paste sample email or link below. When your clients sign up through this link we'll connect them to you.</p>

          {/* <FieldGroup
            readOnly
            onFocus={handleFocus}
            id="formControlsText"
            type="text"
            value={shareTextWithLink}
          /> */}
          <ShareTextWithLink
            shareLink={shareLink}
          />

        </Col>
      </Row>
    </Grid>
  </div>

  export default connect(mapStateToProps, mapDispatchToProps)(MainContentNewClient)



// WEBPACK FOOTER //
// ./src/accountants/MainContentNewClient.js